<template>
  <app-mypage-referral-code-page />
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AppMypageReferralCodePage from '@/views/MypagePage/MypageReferralCodePage.vue'

/**
 * ブラウザ版: マイページ: 紹介コードページ
 */
export default defineComponent({
  name: 'MypageReferralCodePage',
  components: {
    AppMypageReferralCodePage,
  },
})
</script>

<style lang="scss">
.page-wrapper {
  .referral-code-pane {
    max-width: 800px;
    padding-top: 34px;
  }

  .referral-code-section,
  .referral-coupon-section {
    max-width: none;
  }
}
</style>
